import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Title from "../../Text/Title/Title";
import BigText from "../../Text/BigText/BigText";
import { format } from "date-fns";
import {Row, Col, Button} from 'reactstrap'
import { useNotification } from "../../../hooks/useNotification";
import { FillingBottle } from "react-cssfx-loading";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import "./Task.css";

function TaskVersion() {
  const { notify } = useNotification();
  const { getTaskVersions } = useApiRequests();
  const [versions, setVersions] = useState(null);
  const { type } = useParams();

  useEffect(() => {
    const handleFetchData = async () => {
      try {
        const data = await getTaskVersions(type || "");
        if (data.success) {
          setVersions(data.data);
        } else {
          notify(data.msg, { type: "error" });
        }
      } catch (error) {
        notify(error, { type: "error" });
      }
    };
    handleFetchData();
  }, []);

  const handleGoBack = () => {
    const lastHref = localStorage.getItem("lastHref");
    window.location.href = lastHref || "";
  };


  return (
    <div className="page-container">
     
      <Row>
        <Col
        className="title-and-subtitle"
        md={6}>
          <Title>Versões</Title>
        </Col>


        <Col md={6} className="d-flex justify-content-end">
            <Button
                  className='me-5'
                  color="secondary"
                  style={{ height: "44px" }}
                  onClick={() => handleGoBack()}
                >
                  Voltar
                </Button>
          </Col>
        </Row>

      <div className="mt-3" style={{ maxWidth: "1350px" }}>
        {versions == null ? (
          <div className="d-flex flex-column justify-content-center align-items-center gap-5 mt-5">
            <BigText type={1}>Carregando...</BigText>
            <FillingBottle width="100px" height="100px" color="#dddcdc" />
          </div>
        ) : (
          <div
            style={{ maxWidth: "1350px" }}
            className="card-versions-container"
          >
            {versions != null &&
              versions.map((e, index) => {
                return (
                  <div key={index} className="card-versions">
                    <div className="d-flex align-items-center gap-4">
                      <h3>Versão {e.version} | {format(e.publishDate, "dd/MM/yyyy")}</h3>
                    </div>
                    <ul>
                      {e.tasks.map((title, i) => {
                        return <li key={i}> {title} </li>;
                      })}
                    </ul>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
}

export default TaskVersion;
